import { render, staticRenderFns } from "./updateBaseInfo.vue?vue&type=template&id=42772e1e&scoped=true"
import script from "./updateBaseInfo.vue?vue&type=script&lang=js"
export * from "./updateBaseInfo.vue?vue&type=script&lang=js"
import style0 from "../../../../assets/styles/introduce-common.scss?vue&type=style&index=0&id=42772e1e&prod&lang=scss&scoped=true&external"
import style1 from "./updateBaseInfo.vue?vue&type=style&index=1&id=42772e1e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42772e1e",
  null
  
)

export default component.exports